module.exports = __webpack_public_path__ + "img/security.345afa33.svg";